import { Label } from '@gripp/shared-logic';
import { createContext, useContext } from 'react';

export type RoutineLabelPickerRequest = {
  workspaceId: string;
  initialItems: Label[];
  onChange: (items: Label[]) => void;
};

type RoutineLabelPickerContextValue = {
  openLabelPicker: (request: RoutineLabelPickerRequest) => void;
  closeLabelPicker: () => void;
};

export const RoutineLabelPickerContext =
  createContext<RoutineLabelPickerContextValue | null>(null);

export const useRoutineLabelPicker = () =>
  useContext(RoutineLabelPickerContext);
